import gql from 'graphql-tag';
import HelperGraphql from "utils/helper-graphql";
import FieldsTimeslotGroup from 'graphql/fields/FieldsTimeslotGroup'

const fields = {
	'guid': 'String',
	'name': 'String!',
	'position': 'Int',
	'can_book_for_self': 'String!',
	'can_book_for_coworkers': 'String!',
	'can_book_for_external': 'String!',
	'can_only_book_single_timeslot_per_day': 'String!',
	'timeslot_kinds': '[String]',
	'active': 'String!',
};

export default gql(`
	mutation timeslot_group( ${ HelperGraphql.createFields( fields ) } ) {
	    timeslot_group( ${ HelperGraphql.createVariables( fields ) } ) {
	       ${FieldsTimeslotGroup}
	    }
	}
`);

